<template>
    <v-expansion-panels v-model="expanded" style="background-color: transparent">
        <v-expansion-panel expand>
            <v-expansion-panel-title class="v-subheader theme--light">
                {{ label }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
                <div>
                    <div class="pl-0 v-expansion-panel-header text-subtitle-2" />
                    <v-row no-gutters class-name="mb-5">
                        <v-col>
                            <v-banner single-line hide-details dense background-color="white">
                                {{ formatValue(sliderModel[0]) }}
                            </v-banner>
                        </v-col>
                        <v-col>
                            <v-banner single-line hide-details dense background-color="white">
                                {{ formatValue(sliderModel[1]) }}
                            </v-banner>
                        </v-col>
                    </v-row>
                    <v-range-slider
                        v-model="sliderModel"
                        :min="min"
                        :max="max"
                        hide-details
                        :thumb-label="false"
                        :disabled="disabled"
                        @end="end"
                    />
                    <v-divider />
                </div>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'

    @Component
    export class RangeFilter extends Vue {
        @Prop({required: true}) filters
        @Prop({required: true}) label
        @Prop() valueFilter
        @Prop({required: true}) filter
        @Prop({default: 0}) panelExpanded

        expanded = true

        sliderModel = [Infinity, 0]
        min = 0
        max = Infinity

        mounted() {
            this.expanded = this.panelExpanded

            if (this.filters[this.filter] && this.filters[this.filter][0] <= this.filters[this.filter][1]) {
                this.min = this.filters[this.filter][0]
                this.max = this.filters[this.filter][1]
                this.sliderModel = [this.filters[this.filter][0], this.filters[this.filter][1]]
            }
        }

        @Watch('firstFilterValue')
        onFirstFilterValueChange(val) {
            this.min = val
            this.sliderModel = [val, this.sliderModel[1]]
            this.end()
        }

        @Watch('secondFilterValue')
        onSecondFilterValueChange(val) {
            this.max = val
            this.sliderModel = [this.sliderModel[0], val]
            this.end()
        }

        end() {
            this.$emit('change', {key: this.filter, value: this.sliderModel})
        }

        formatValue(val) {
            return this.$filters[this.valueFilter]?.(val) || val
        }

        get firstFilterValue() {
            return this.filters[this.filter][0]
        }

        get secondFilterValue() {
            return this.filters[this.filter][1]
        }

        get disabled() {
            return this.max === Infinity
        }
    }

    export default RangeFilter
</script>
